// extracted by mini-css-extract-plugin
export default {"oranum":"oranum--zYX10AxOPRe3Bdp"};